import { sagas as messageSagas } from './modules/messages'

export default [...messageSagas]
